export default __webpack_public_path__ + "static/media/bill-2-selected.8d727836.svg";